import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";

const VisaDetails = ({ employee }) => {
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Visa Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Visa Number</th>
                  <th>Type of Visa</th>
                  <th>Duration</th>
                  <th>Issue Date</th>
                  <th>Expiry Date</th>
                  <th>Issued By</th>
                  <th>Sponsorship</th>
                  <th>Business Visa</th>
                  <th>Country</th>
                  <th>Agent Name</th>
                  <th>Agent Phone</th>
                  <th>Agent Email</th>
                </tr>
              </thead>
              <tbody>
                {employee?.otherVisaDetails?.map((visa) => (
                  <tr key={visa.visaNumber}>
                    <td>{visa.visaNumber}</td>
                    <td>{visa.typeofVisa}</td>
                    <td>{visa.duration}</td>
                    <td>{visa.issuesDate && format(new Date(visa.issuesDate), "yyyy-MM-dd")}</td>
                    <td>{visa.expiryDate && format(new Date(visa.expiryDate), "yyyy-MM-dd")}</td>
                    <td>{visa.issuedBy}</td>
                    <td>{visa.sposorship}</td>
                    <td>{visa.busniessVisa}</td>
                    <td>{visa.country}</td>
                    <td>{visa.agentName}</td>
                    <td>{visa.agentPhone}</td>
                    <td>{visa.agentEmail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

VisaDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default VisaDetails;
